import React from 'react';

function LoadingSpinner() {
    return (
        <div>
            <div className="spinner-grow spinner-grow-sm text-danger" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow spinner-grow-sm text-warning" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow spinner-grow-sm text-info" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <br />
            Load data
        </div>
    );
}

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/LoadingSpinner.js